import React, { useState, useEffect, useCallback } from "react";
import { Grid, Card, Icon, Header, Image, List, Container, Button, } from "semantic-ui-react";
import APIService from "../../Services/API/APIService";
import { Link, useNavigate } from "react-router-dom";
import img2 from '../../Assets/img2.jpg'
import CheckRoom from "./CheckRoom";
import numeral from "numeral";

const Home = (props) => {

  const [loading, setLoading] = useState(false);
  const [rooms, setRooms] = useState();
  const navigate = useNavigate()
  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true);
      if (isSubscribed) {
      let result = await APIService.getData("/guest-house/getPackages");
        setRooms(result);
      }

    } catch (error) {
      setLoading(false);
    }
  }, [])

  useEffect(() => {
    let isSubscribed = true;

    fetchData(isSubscribed);
    return () => (isSubscribed = false);
  }, [fetchData]);



  return (


    <Container fluid>
      <Grid>

        <Grid.Row>
          <Grid.Column width={16}>
            <div style={{
              backgroundImage: 'url(' + img2 + ')',
              height: '100vh', width: '100%', backgroundPosition: 'center', backgroundAttachment: 'fixed', marginTop: '-1.5rem',
              backgroundSize: 'cover'
            }}>
              <div style={{ justifyContent: 'center', alignItems: 'center', height: '100vh', display: 'flex' }}>


                <CheckRoom />
              </div>
            </div>

          </Grid.Column>


        </Grid.Row>
      </Grid>

      {!rooms && !loading && (
        <div style={{ textAlign: "center" }}>
          <Image
            as="a"
            src={""}
            centered
            onClick={() => navigate(`customer`)}
          />
        </div>
      )}

      {/* <Header textAlign="center" style={{ backgroundColor: '#26f09e', color: '#000000', padding: '0.4em', marginBottom: '2em' }}>  OUR ROOMS</Header>


      <Card.Group itemsPerRow={3} stackable>

        {rooms?.map((item) => (
          <Card
            key={item.roomCode}
            color='teal'
            as={Link}
            to={{
              pathname: `rooms/${item.roomCode}`,
            }}
            fluid
          >

            {item.GuestHouseGalleries[0] && (
              <div style={{
                backgroundImage: 'url(' + item.GuestHouseGalleries[0]?.resizeLocation + ')',
                height: 400, width: '100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'
              }}>

                <Header style={{ position: 'absolute', backgroundColor: 'rgba(38, 240, 153, 0.6)', color: '#000000', padding: '0.3em', borderRadius: '7px' }}>{item.name}  <Icon name='' /> ₦{numeral(item?.price).format("0,0")}  </Header>

              </div>

            )}

            <Card.Description size="large" style={{ color: '#000' }}>
              <List horizontal divided size="large">
                {item.description.split("\n").map((item, index) =>
                  <List.Item key={index}>
                    <List.Content>
                      <Icon name="arrow alternate circle right" />
                      {item}

                    </List.Content>
                  </List.Item>
                )}

              </List>
            </Card.Description>
            <Button style={{ backgroundColor: '#26f09e', color: '#000000' }} onClick={() => navigate(`rooms/${item.roomCode}`)}>
              View Our Deal
            </Button>
          </Card>
        ))}
      </Card.Group> */}
    </Container>
  );
};

export default Home;
